import VoicesCampaignDetail from "../Components/Voices/Campaigns/VoicesCampaignDetail";

const VoicesCampaignPage = () => {
  return <VoicesCampaignDetail />;
};

export default VoicesCampaignPage;
